import {
  QuestionType,
  RoomType,
  CalculateProps,
  OffertType,
  EstimateType,
  UpdateProps,
  OrderType,
  WpResponse,
  OrderError,
} from './types';

const headers = {
  accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
};

export const getQuestions = async (): Promise<QuestionType[]> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/questions`, {
    headers,
  });
  return response.json();
};

export const getCategories = async (): Promise<any> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/categories`, {
    headers,
  });
  return await response.json();
};

export const getRoomInfo = async (
  data: RoomType
): Promise<Partial<RoomType>> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/info`, {
    headers,
    body: JSON.stringify(data),
    method: 'POST',
  });
  if (response.ok) {
    return await response.json();
  }
  throw new Error(
    response.status === 422
      ? 'De värden du anger verkar inte stämma, vänligen ange dina mått i centimeter.'
      : 'Error'
  );
};

export const getEstimate = async (
  data: EstimateType
): Promise<Partial<RoomType>> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/estimate`, {
    headers,
    body: JSON.stringify(data),
    method: 'POST',
  });
  return await response.json();
};

export const calculate = async (data: CalculateProps): Promise<OffertType> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/calculate`, {
    headers,
    body: JSON.stringify(data),
    method: 'POST',
  });
  return await response.json();
};

export const updateOrder = async (
  data: UpdateProps
): Promise<OrderError | boolean> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/edit`, {
    headers,
    body: JSON.stringify(data),
    method: 'POST',
  });
  if (response.ok) {
    return true;
  }
  throw new Error(
    response.status === 422
      ? 'De värden du anger verkar inte stämma, vänligen ange dina mått i centimeter.'
      : 'Error'
  );
};

export const getOrder = async (id: string): Promise<OrderError | OrderType> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/order/${id}`, {
    headers,
  });
  return await response.json();
};

export const sendEstimate = async (data: any): Promise<WpResponse> => {
  const response = await fetch(
    `${process.env.REACT_APP_WP_URL}/wp-json/headless/paintorder`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    }
  );
  return await response.json();
};
